import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Card, Skeleton, Space } from 'antd';
import { PageHeaderSkeleton } from '../List';

var ResultPageSkeleton = function ResultPageSkeleton(_ref) {
  var _ref$active = _ref.active,
      active = _ref$active === void 0 ? true : _ref$active,
      pageHeader = _ref.pageHeader;
  return _jsxs("div", {
    style: {
      width: '100%'
    },
    children: [pageHeader !== false && _jsx(PageHeaderSkeleton, {
      active: active
    }), _jsx(Card, {
      children: _jsxs("div", {
        style: {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
          padding: 128
        },
        children: [_jsx(Skeleton.Avatar, {
          size: 64,
          style: {
            marginBlockEnd: 32
          }
        }), _jsx(Skeleton.Button, {
          active: active,
          style: {
            width: 214,
            marginBlockEnd: 8
          }
        }), _jsx(Skeleton.Button, {
          active: active,
          style: {
            width: 328
          },
          size: "small"
        }), _jsxs(Space, {
          style: {
            marginBlockStart: 24
          },
          children: [_jsx(Skeleton.Button, {
            active: active,
            style: {
              width: 116
            }
          }), _jsx(Skeleton.Button, {
            active: active,
            style: {
              width: 116
            }
          })]
        })]
      })
    })]
  });
};

export default ResultPageSkeleton;